import { render, staticRenderFns } from "./QHforget.vue?vue&type=template&id=fa394bb2"
import script from "./QHforget.vue?vue&type=script&lang=js"
export * from "./QHforget.vue?vue&type=script&lang=js"
import style0 from "./QHforget.vue?vue&type=style&index=0&id=fa394bb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports